import { render, staticRenderFns } from "./radio-modal-slots.mpx?vue&type=template&id=d1036f20&isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex"
import script from "./radio-modal-slots.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex"
export * from "./radio-modal-slots.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex"
import style0 from "./radio-modal-slots.mpx?vue&type=style&index=0&id=d1036f20&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_85d2da0c%22%7D&isComponent&outputPath=components%2Fradio-modal-slots85d2da0c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports